import { useApi } from "../api";

export const useInspectionService = () => {
  const api = useApi();

  return {
    /**
     * Procesa archivos Excel para extraer información
     */
    uploadAndProcessExcel: async (formData) => {
      try {
        let dataToSend = formData;
        
        if (Array.isArray(formData)) {
          dataToSend = new FormData();
          formData.forEach((file) => {
            dataToSend.append('files', file);
          });
        }
        
        const response = await api.post('/process-inspection/excel/upload', dataToSend, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 120000
        });
        return response.data;
      } catch (error) {
        console.error('Error procesando archivos Excel:', error);
        throw error.response?.data || error;
      }
    },

    /**
     * Guarda inspecciones procesadas (vehículos o operadores)
     */
    saveInspections: async (payload) => {
      try {
        const { type, data } = payload;
        const response = await api.post('/process-inspection/inspections', { type, data });
        return response.data;
      } catch (error) {
        console.error('Error guardando registros:', error);
        throw error.response?.data || error.message;
      }
    },

    /**
     * Verifica entidades existentes por identificador
     */
    checkExistingEntities: async (data) => {
      try {
        const response = await api.post('/process-inspection/inspections/check', data);
        return response.data;
      } catch (error) {
        console.error('Error verificando entidades existentes:', error);
        throw error.response?.data || error.message;
      }
    },

    /**
     * Actualiza una entidad existente (vehículo u operador)
     */
    updateEntity: async (id, data, type = 'vehicle') => {
      try {
        const response = await api.put(`/process-inspection/inspections/${id}?type=${type}`, data);
        return response.data;
      } catch (error) {
        console.error(`Error actualizando ${type} ${id}:`, error);
        throw error.response?.data || error.message;
      }
    },

    /**
     * Elimina una entidad
     */
    deleteEntity: async (id, type = 'vehicle') => {
      try {
        const response = await api.delete(`/process-inspection/inspections/${id}?type=${type}`);
        return response.data;
      } catch (error) {
        console.error(`Error eliminando ${type} ${id}:`, error);
        throw error.response?.data || error.message;
      }
    },

    /**
     * Obtiene entidades con filtros y paginación
     */
    getEntities: async (filters = {}, type = 'vehicles') => {
      try {
        const response = await api.get('/process-inspection/inspections', { 
          params: { ...filters, type } 
        });
        return response.data;
      } catch (error) {
        console.error(`Error obteniendo ${type}:`, error);
        throw error.response?.data || error.message;
      }
    },

    /**
     * Genera Excel con entidades
     */
   exportToExcel: async (params = {}, type = 'vehicles', exportType) => {
    try {
      let response;
      const exportParams = { 
        ...params, 
        type,
        exportType
      };
      
      if (type === 'vehicles' && params.selectedPlates && params.selectedPlates.length > 0) {
        response = await api.post('/process-inspection/inspections/export', 
          { selectedPlates: params.selectedPlates },
          { params: exportParams, responseType: 'blob' }
        );
      } else if (type === 'operators' && params.selectedOperatorIds && params.selectedOperatorIds.length > 0) {
        response = await api.post('/process-inspection/inspections/export', 
          { selectedOperatorIds: params.selectedOperatorIds },
          { params: exportParams, responseType: 'blob' }
        );
      } else {
        response = await api.get('/process-inspection/inspections/export', { 
          params: exportParams,
          responseType: 'blob'
        });
      }
      return response.data;
    } catch (error) {
      console.error('Error exportando a Excel:', error);
      throw error.response?.data || error.message;
    }
  },
    
    /**
     * Actualiza registro duplicado
     */
    updateDuplicateEntity: async (updateData) => {
      try {
        const response = await api.post('/process-inspection/inspections/update-duplicate', updateData);
        return response.data;
      } catch (error) {
        console.error('Error actualizando duplicado:', error);
        throw error.response?.data || error.message;
      }
    },
  };
};